import baseController from './base'
import { objectKeysToCamelCase } from '../common/case-style-conversion'

const formController = {
  extends: baseController,

  data() {
    return {
      disabled: false,
      errors: {},
      successMessage: '',
      successFeedback: ''
    }
  },

  computed: {
    hasGlobalErrors() {
      if (this.errors.nonFieldErrors || this.errors.detail || this.errors.token) {
        return true
      }
    }
  },

  methods: {
    submitted() {
      this.disabled = true
    },

    failed(response) {
      this.errors = Object.entries(objectKeysToCamelCase(response.responseJSON)).reduce(
        (obj, [field, value]) => {
          const errors = Array.isArray(value) ? value : [value]
          if (field === 'token') {
            obj[field] = 'This token is no longer valid. Please try again.'
          } else {
            obj[field] = errors.join(' ')
          }
          return obj
        },
        {}
      )
      this.successFeedback = ''
    },

    always() {
      this.disabled = false
    },

    succeed(response) {
      this.successFeedback = response.success || this.successMessage
      this.errors = {}
    }
  }
}

export default formController
